import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Ellipsis, Swiper } from 'antd-mobile'

import styles from './index.module.less'
import RelateTagList from '../../../components/RelateTagList'
import CurrencySymbol from '../../../components/CurrencySymbol'
import { renderImageUrl } from '../../../utils'
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'
import AutoImage from '../../../components/AutoImage'
import defaultImg from '../../../assets/images/def_img_food.png'
import defView from '../../../assets/images/def_view.png'
import PriceText from '../../../components/ProductMenu/PriceText'
import { setFromView } from '../../../utils/session/store'

export default function RestaurantCard({ list = [], title = '', areaId }) {
    const navigate = useNavigate()
    const [failedImages, setFailedImages] = useState({})
    const renderProduct = (products = [], productImages = '') => {
        if (products.length === 0) return null
        const img = productImages || defaultImg
        return (
            <Swiper
                autoplay
                loop
                indicator={() => null}
            >
                {
                    products.map((product, index) => (
                        <Swiper.Item key={index}>
                            <div className={styles.productItem}>
                                <AutoImage src={product.images || img} alt="product-image" onError={(e) => { e.target.src = img }} />
                                <div className={styles.productInfo}>
                                    <div className={`${styles.productName}`}><Ellipsis content={product.name} /></div>
                                    <div className={styles.productPrice}><PriceText product={product} /></div>
                                </div>
                            </div>
                        </Swiper.Item>
                    ))
                }
            </Swiper>

        )
    }

    const handleImageError = (itemId) => {
        setFailedImages(prev => ({ ...prev, [itemId]: true }))
    }

    const renderBackgroundImage = (item) => {
        const { image, productImages = '', partnerId } = item
        const nImage = productImages || defView
        if (failedImages[partnerId]) {
            return `url(${nImage})`
        }
        
        const imageUrl = renderImageUrl({ size: 'b', src: image || nImage })
        // 创建一个临时图片对象来测试图片是否可以加载
        const img = new Image()
        img.onerror = () => handleImageError(partnerId)
        img.src = imageUrl
        return `url(${imageUrl})`
    }
    return (
        <div className={styles.restaurantCard}>
            <div className={styles.restaurantTitle}>{title}</div>
            <div className={styles.restaurantBody}>
                {
                    list.map((item, index) => (
                        <div key={index}
                            onClick={() => {
                                let text = `areaid=${areaId}&partnerid=${item.partnerId}&hotel=${item.shortName || item.name}&storeid=${item.storeId}`
                                // let view = item.type === 7 ? 'restaurant' : 'catering'
                                let view = 'restaurant'

                                setFromView(null)
                                navigate(`/${view}?${text}`, { state: { storeInfo: item } })

                                addBehaviorsRecord({
                                    behaviorType: 160200,
                                    behavior: 160205,
                                    storeId: item.storeId,
                                })
                            }}>
                            <div className={styles.restaurantItemBox}>
                                <div className={styles.restaurantItem}
                                    style={{
                                        backgroundImage: renderBackgroundImage(item),
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}>
                                    <div className={styles.cardImgBox}>&nbsp;
                                        {/* <AutoImage src={item.image || defaultImg} alt="product-image" onError={(e) => { e.target.src = defaultImg }} /> */}
                                        {/* <img src={item.image} alt={item.name} /> */}
                                    </div>
                                    <div className={styles.resInfo}>
                                        <div className={`${styles.resName} ellips`}>{item.shortName || item.name}</div>
                                        <div className={`${styles.description} ellips hide`}> <small>{item.description}</small> </div>
                                        <div className={`${styles.mcTag} scroll-x`} style={{ height: 31 }}><RelateTagList list={item.tagRelates} wrap={false} /></div>

                                        {
                                            (item.products?.length > 0 || item.recommendMeal?.length > 0) && (
                                                <div className={styles.rlProducts}>
                                                    {
                                                        renderProduct(item.recommendMeal?.length > 0 ? item.recommendMeal : item.products, item.productImages)
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
